import intl from 'react-intl-universal';
import { User } from 'utils/customTypes';
import { LearningTeam } from './learningTeamSlice';
import { LearningTeamWithMembers } from 'utils/types/learningTeam';
import { SnackBarNotificationParams } from 'Hooks/useSnackbarNotification';

interface SerializedLearningTeam {
  learningTeam: LearningTeam;
  entities: Map<string, User>;
}

export const serializeLearningTeam = (
  learningTeam: LearningTeamWithMembers
): SerializedLearningTeam => {
  const usersMap = new Map<string, User>();
  const membersIds: string[] = [];
  const managersIds: string[] = [];
  for (const member of learningTeam.ldTeamMembers) {
    usersMap.set(member.id, member);
    membersIds.push(member.id);
  }
  for (const manager of learningTeam.teamManagers) {
    usersMap.set(manager.id, manager);
    managersIds.push(manager.id);
  }
  return {
    learningTeam: {
      ...learningTeam,
      membersIds,
      managersIds,
    },
    entities: usersMap,
  };
};

export const generateSuccessNotification = (): SnackBarNotificationParams => {
  return {
    notificationVariant: 'success',
    notificationTitle: intl.get(
      'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.UPDATED_SUCCESS_NOTIFICATION'
    ),
  };
};

export const generateErrorNotification = (): SnackBarNotificationParams => {
  return {
    notificationVariant: 'error',
    notificationTitle: intl.get('SNACKBAR_ERROR_NOTIFICATION_TITLE'),
    notificationMessage: intl.get(
      'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.UPDATED_ERROR_NOTIFICATION'
    ),
  };
};

export const generateUpdateLDTeamMembersNotifications = (
  successCount: number,
  errorCount: number
): SnackBarNotificationParams[] => {
  const notifications: SnackBarNotificationParams[] = [];
  if (successCount > 0) {
    notifications.push({
      notificationVariant: 'success',
      notificationTitle: intl.get(
        'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.UPDATED_TEAM_MEMBERS_SUCCESS_NOTIFICATION',
        { num: successCount, op: successCount }
      ),
    });
  }
  if (errorCount > 0) {
    notifications.push({
      notificationVariant: 'error',
      notificationTitle: intl.get('SNACKBAR_ERROR_NOTIFICATION_TITLE'),
      notificationMessage: intl.get(
        'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.UPDATED_TEAM_MEMBERS_ERROR_NOTIFICATION',
        { num: errorCount, op: errorCount }
      ),
    });
  }
  return notifications;
};

export const generateRemoveTeamMemberNotification = (
  succeeded: boolean
): SnackBarNotificationParams => {
  if (succeeded) {
    return {
      notificationVariant: 'success',
      notificationTitle: intl.get(
        'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.REMOVE_MEMBER_CONFIRMATION_MODAL.SUCCESS_NOTIFICATION'
      ),
    };
  }
  return {
    notificationVariant: 'error',
    notificationTitle: intl.get('SNACKBAR_ERROR_NOTIFICATION_TITLE'),
    notificationMessage: intl.get(
      'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.REMOVE_MEMBER_CONFIRMATION_MODAL.ERROR_NOTIFICATION'
    ),
  };
};
